import { BaseModel } from './base-model';
import { Company } from './company';

export enum UserRole {
  admin = 'admin',
  employee = 'employee',
  superAdmin = 'superAdmin',
  // CRAT-975 — inventory-only role: create/view/edit individual items; no orders, no bulk editing.
  lister = 'lister',
}

export const UserRoleTranslations: Record<UserRole, string> = {
  [UserRole.admin]: 'Admin',
  [UserRole.employee]: 'Employee',
  [UserRole.superAdmin]: 'Super Admin',
  [UserRole.lister]: 'Lister',
};

// CRAT-975 — the standard "any normal user" allow-list used as the default for route role-gating.
// Deliberately EXCLUDES the restricted `lister` role, so a Lister is only granted access where it's
// listed explicitly (least privilege). Inventory + Settings opt the Lister in via `UserRolesWithLister`.
export const UserRoleAll = [UserRole.admin, UserRole.employee, UserRole.superAdmin];
export const UserRolesWithLister = [...UserRoleAll, UserRole.lister];

export enum UserStatus {
  enabled = 'enabled',
  disabled = 'disabled',
  invited = 'invited',
}

interface BaseUser extends BaseModel {
  email: string;
  status: UserStatus;
}

export interface InviteUserData {
  email: string;
  fullName: string;
  role: UserRole;
}

export interface UpdateUserData {
  fullName: string;
  currentPassword?: string;
  newPassword?: string;
}

export interface User extends BaseUser {
  fullName: string;
  profilePicture?: string;
  profilePictureUrl?: string;
  role: UserRole;
  companyId: string;
  company?: Company;
}
